import React, { useEffect, useMemo, useRef, useState } from "react";

import { useReturnToScroll } from "@hooks/useReturnToScroll";
import { WindowsScrollerWrapper } from "@lib/virtualization-components";
import classNames from "classnames";
import { observer } from "mobx-react";

import LiveSkeletonLoader from "./live-virtualized-offer-components/LiveSkeletonLoader";
import SportsList from "./live-virtualized-offer-components/LiveVirtualizedOfferSports";

export default observer(function VirtualizedOfferInner(props: {
	store: {
		isEmpty: boolean;
		isLoading: boolean;
		isFetchingData: boolean;
		isStoreInitialized: boolean;
		period: string;
	} & Parameters<typeof SportsList>[0]["store"];
}) {
	const isWorking = useReturnToScroll(
		props.store.isLoading ||
			props.store.isFetchingData ||
			!props.store.isStoreInitialized,
		window
	);

	const [height, setHeight] = useState<number>(0);
	const [el, setEl] = useState<HTMLElement | null>(null);

	//#region observe element width

	const setWidthRef = useRef(() => {});
	setWidthRef.current = () => setHeight(el?.clientHeight || 0);

	const resizeObserver = useMemo(
		() =>
			new ResizeObserver(() => {
				setWidthRef.current();
			}),
		[]
	);

	const isLiveViewGrouped = props.store.isGroupedByTournament;

	useEffect(() => {
		el && resizeObserver.observe(el);
	}, [el]);

	useEffect(() => {
		return () => resizeObserver.disconnect();
	}, []);

	if (props.store.isLoading) {
		return <LiveSkeletonLoader />;
	}

	return (
		<div
			ref={(newRef) => setEl(newRef)}
			className={classNames(
				"offer offer--virtual offer--live offer--full",
				{
					"offer--live--grouped": isLiveViewGrouped,
				}
			)}
		>
			<WindowsScrollerWrapper scrollElement={null}>
				<SportsList
					store={props.store}
					isScrollRestoreWorking={isWorking}
					listHeight={height}
				/>
			</WindowsScrollerWrapper>
		</div>
	);
});
